import {Injectable} from '@angular/core';
import {fromEvent, Observable, merge} from 'rxjs';
import {map, startWith, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ConnectionService {
  connected$!: Observable<boolean>;
  connected: boolean = navigator.onLine;

  constructor() {
    this.connected$ = merge(
      fromEvent(window, 'online').pipe(map(() => true)),
      fromEvent(window, 'offline').pipe(map(() => false))
    ).pipe(
      startWith(navigator.onLine),
      tap(connected => (this.connected = connected))
    );
  }
}
